// extracted by mini-css-extract-plugin
export default {"page":"Ajuda_page__CaAV6","containerSobre":"Ajuda_containerSobre__vuL0n","titulo":"Ajuda_titulo__W+AJD","frase":"Ajuda_frase__5B23M"};